module.exports = __webpack_public_path__ + "bcf28913592719446b90bb8fce9a7fdd.png";